import { useEffect, useState } from 'react';
import { useLocation, Navigate } from 'react-router';
import { useAuthStore } from '@/store/auth';
import { useAccess } from '@/hooks/useAccess';
import Forbidden from '@/pages/403';
import { currentUser as currentUserAPI } from '@/services/ant-design-pro/api';
// import { Spin } from 'antd';
// import FullScreenLoading from './FullScreenLoading';

type AccessKey = keyof ReturnType<typeof useAccess>;

interface AuthGuardProps {
  children: React.ReactNode;
  requiredAccess?: AccessKey;
}

export default function AuthGuard({ children, requiredAccess }: AuthGuardProps) {
  const { currentUser, setCurrentUser } = useAuthStore();
  const [loading, setLoading] = useState(true);
  const access = useAccess();
  const location = useLocation();

  /**
   * 获取当前登录用户信息
   */
  const getCurrentUser = async () => {
    try {
      setLoading(true);
      const { data } = await currentUserAPI({ skipErrorHandler: true });
      setCurrentUser(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCurrentUser();
  }, []);

  // if (loading) {
  //   return <Spin size="large" tip="加载中..." fullscreen rootClassName="app-fullscreen-spin" />;
  //   // return <FullScreenLoading />;
  // }

  if (!loading && !currentUser) {
    return <Navigate to="/user/login" state={{ from: location }} replace />;
  }

  // 已登录但权限不足：在当前布局的主内容区域内直接展示 403，而不是整页跳转到独立的 /403 路由，
  // 这样能保留外层布局（侧边栏/头部）不变
  if (!loading && requiredAccess && !access[requiredAccess]) {
    return <Forbidden />;
  }

  return children;
}
